import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import { findDOMNode } from 'react-dom';
import { connect, Dispatch } from 'react-redux';

import { CalendarActions, ICalendarState } from "@adage/ace-calendar";
import { IArenaEvent } from '../classes/event';

declare var numberOfMonths: number;

function isElementVisible(el: Element, scroll?: boolean): boolean {
    let rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

interface LoaderExternalProps {

}

interface StateToProps {
    endDate: moment.Moment;
    startDate: moment.Moment;
    updating: boolean;
}

interface LoaderState {
    noMoreMonths: boolean;
    lastMonthToDisplay: moment.Moment;
}

type LoaderProps = LoaderExternalProps & StateToProps;

class Loader extends React.Component<LoaderProps, LoaderState> {
    constructor(props: LoaderProps) {
        super(props);
        this.state = {
            noMoreMonths: false,
            // Sutract 1 because it includes the current month in the calculations.
            lastMonthToDisplay: moment().clone().add(numberOfMonths - 1, "months"),
        }
    }

    componentDidMount() {
        window.addEventListener("scroll", this.onBoundScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.onBoundScroll);
    }

    componentWillReceiveProps(props: LoaderProps) {
        // Use this.props or else it'll keep loading future months each time there's an update.
        const element = findDOMNode(this) as Element;
        const noMoreMonths = this.props.endDate.isAfter(this.state.lastMonthToDisplay);
        if (!this.props.updating && isElementVisible(element) && !noMoreMonths) {
            CalendarActions.setDates(this.props.startDate, this.props.endDate.clone().add(1, "month").endOf("month"));
        }

        if (noMoreMonths) {
            this.setState({
                noMoreMonths: true
            });
        }
    }

    private onBoundScroll = _.debounce(this.onScroll.bind(this), 500, {
        leading: true,
        trailing: false
    });

    private onScroll() {
        const element = findDOMNode(this) as Element;
        const noMoreMonths = this.props.endDate.isAfter(this.state.lastMonthToDisplay);
        if (isElementVisible(element) && !noMoreMonths) {
            CalendarActions.setDates(this.props.startDate, this.props.endDate.clone().add(1, "month").endOf("month"));
        }
    }

    render() {
        return (
            <div className={`loader-container`} >
                {
                    this.state.noMoreMonths ? <p>All events have been loaded</p> : <div className="loader">Loading&hellip;</div>
                }
            </div>
        );
    }
}

function mapStateToProps(state: ICalendarState<IArenaEvent>, externalProps: LoaderExternalProps) {
    return {
        endDate: state.endDate,
        startDate: state.startDate,
        updating: state.updating
    }
}

export default connect<StateToProps>(mapStateToProps)(Loader);


// WEBPACK FOOTER //
// ./app/calendar/components/loader.tsx